/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FacialFrontal1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import FacialFrontal from 'DesignSystem/Images/FacialFrontal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function FacialFrontal1({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Instructions/Illustrations/Illustration/FacialFrontal"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<FacialFrontal
  viewPath={`${viewPath}/FacialFrontal`}
 width="100%"
 height="100%"
 objectFit="contain"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceM}
 marginLeft="auto"
 marginRight="auto"
/>
{children}
</React.Fragment>)
}